import React from 'react';
import Slider from 'react-slick';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import useMediaQuery from '@mui/material/useMediaQuery';
import AnkeImage from '/public/images/company/anke.png';
// import AntaImage from '/public/images/company/anta.png';
import CompalImage from '/public/images/company/compal.png';
import FendaImage from '/public/images/company/fenda.png';
import FushanImage from '/public/images/company/fushan.png';
import FushikangImage from '/public/images/company/fushikang.png';
import GeerImage from '/public/images/company/geer.png';
import GeliboImage from '/public/images/company/gelibo.png';
import GemtekImage from '/public/images/company/gemtek.png';
// import GgecImage from '/public/images/company/ggec.png';
import GuangbaoImage from '/public/images/company/guangbao.png';
import HanyangImage from '/public/images/company/hanyang.png';
import HaoenImage from '/public/images/company/haoen.png';
import HeertaiImage from '/public/images/company/heertai.png';
import HeshuoImage from '/public/images/company/heshuo.png';
// import JingDongFangImage from '/public/images/company/jingdongfang.png';
import JiTuImage from '/public/images/company/jitu.png';
// import LansiImage from '/public/images/company/lansi.png';
import LeishizhaomingImage from '/public/images/company/leishizhaoming.png';
// import LingJiImage from '/public/images/company/lingji.png';
import LingYunGuangImage from '/public/images/company/lingyunguang.png';
import LiuGongImage from '/public/images/company/liugong.png';
import LixunImage from '/public/images/company/lixun.png';
import PlariumImage from '/public/images/company/plarium.png';
import RunTongImage from '/public/images/company/runtong.png';
import SanHuaImage from '/public/images/company/sanhua.png';
// import TCLImage from '/public/images/company/tcl.png';
// import VSunImage from '/public/images/company/vsun.png';
// import WeiZhenNiImage from '/public/images/company/weizhenni.png';
import WistronImage from '/public/images/company/wistron.png';
import WoLongImage from '/public/images/company/wolong.png';
import WooSungImage from '/public/images/company/woosung.png';

const mock = [
  AnkeImage,
  // AntaImage,
  CompalImage,
  FendaImage,
  FushanImage,
  FushikangImage,
  GeerImage,
  GeliboImage,
  GemtekImage,
  // GgecImage,
  GuangbaoImage,
  HanyangImage,
  HaoenImage,
  HeertaiImage,
  HeshuoImage,
  // JingDongFangImage,
  JiTuImage,
  // LansiImage,
  LeishizhaomingImage,
  // LingJiImage,
  LingYunGuangImage,
  LiuGongImage,
  LixunImage,
  PlariumImage,
  RunTongImage,
  SanHuaImage,
  // TCLImage,
  // VSunImage,
  // WeiZhenNiImage,
  WistronImage,
  WoLongImage,
  WooSungImage,
];

const LogoSliders = (): JSX.Element => {
  const theme = useTheme();
  const t = useTranslations('Compliant.logoSliders');
  const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
    defaultMatches: true,
  });
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  });

  let slidesToShow = 2;
  if (isXs) {
    slidesToShow = 2;
  }
  if (isSm) {
    slidesToShow = 3;
  }
  if (isMd) {
    slidesToShow = 4;
  }
  if (isLg) {
    slidesToShow = 6;
  }

  const sliderOpts = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <Box>
      <Box>
        <Box marginBottom={4}>
          <Typography
            gutterBottom
            align={'center'}
            variant={'h4'}
            fontWeight={700}
          >
            {t('title')}
          </Typography>
          <Typography color={'text.secondary'} align={'center'} variant={'h6'}>
            {t('description')}
          </Typography>
        </Box>
        <Box
          sx={{
            py: {
              xs: 2,
              md: 4,
            },
          }}
        >
          <Slider
            {...sliderOpts}
            style={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
            }}
          >
            {mock.map((item, i) => (
              <Box maxWidth={128} key={i} marginX={3}>
                <Box
                  component="img"
                  height={1}
                  width={1}
                  src={`${item.src}`}
                  alt="coperation company logo"
                  sx={{
                    filter:
                      theme.palette.mode === 'dark'
                        ? 'brightness(0) invert(0.7)'
                        : 'none',
                  }}
                />
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default LogoSliders;
